module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('el-form', {
    ref: "queryForm",
    attrs: {
      "size": "mini",
      "inline": true,
      "label-position": "left",
      "label-width": _vm.queryFormLabelWidth,
      "model": _vm.queryForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "店铺名称",
      "prop": "shop_id"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "clearable": "",
      "remote-method": _vm.remoteShopMethod,
      "placeholder": "请输入店铺"
    },
    model: {
      value: (_vm.queryForm.shop_id),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "shop_id", $$v)
      },
      expression: "queryForm.shop_id"
    }
  }, _vm._l((_vm.shopList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "投诉原因",
      "prop": "complaintReason"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.queryForm.complaintReason),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "complaintReason", $$v)
      },
      expression: "queryForm.complaintReason"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "超1小时未收到商品",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "漏商品、送错商品",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "商品质量问题",
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "申请退款",
      "value": "4"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "投诉商家",
      "value": "5"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "投诉西游侠",
      "value": "6"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "投诉职能人员",
      "value": "7"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系电话",
      "prop": "linkmanTel"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.queryForm.linkmanTel),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "linkmanTel", $$v)
      },
      expression: "queryForm.linkmanTel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "处理状态",
      "prop": "status"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.queryForm.status),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "status", $$v)
      },
      expression: "queryForm.status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "新增投诉/待处理",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已受理",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "处理完成",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已判断",
      "value": "3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否有效",
      "prop": "isValid"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.queryForm.isValid),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "isValid", $$v)
      },
      expression: "queryForm.isValid"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "否",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "是",
      "value": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "日期",
      "prop": "date"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "placeholder": "请选择日期"
    },
    model: {
      value: (_vm.queryForm.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "dateRange", $$v)
      },
      expression: "queryForm.dateRange"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.fetchData(_vm.queryForm.pageNo = 1)
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('queryForm')
      }
    }
  }, [_vm._v("重置")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('el-row', {
    staticClass: "pb20"
  }, [_c('export-excel', {
    attrs: {
      "params": _vm.exportParams,
      "action": _vm.$apiUrl.complaintList,
      "target": 'oc',
      "field": _vm.field,
      "filename": _vm.fileName,
      "fieldname": _vm.fieldName
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "cityName",
      "label": "城市名称",
      "show-overflow-tooltip": true,
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "schoolName",
      "label": "学校名称",
      "show-overflow-tooltip": true,
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "supplierShortName",
      "label": "店铺名称",
      "show-overflow-tooltip": true,
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "投诉时间",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.$utils.formatDate(scope.row.createTime)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "linkmanTel",
      "label": "联系电话",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "complaintReason",
      "label": "投诉原因",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.complaintReason == 1) ? _c('span', [_vm._v("超1小时未收到商品")]) : _vm._e(), _vm._v(" "), (scope.row.complaintReason == 2) ? _c('span', [_vm._v("漏商品、送错商品")]) : _vm._e(), _vm._v(" "), (scope.row.complaintReason == 3) ? _c('span', [_vm._v("商品质量问题")]) : _vm._e(), _vm._v(" "), (scope.row.complaintReason == 4) ? _c('span', [_vm._v("申请退款")]) : _vm._e(), _vm._v(" "), (scope.row.complaintReason == 5) ? _c('span', [_vm._v("投诉商家")]) : _vm._e(), _vm._v(" "), (scope.row.complaintReason == 6) ? _c('span', [_vm._v("投诉西游侠")]) : _vm._e(), _vm._v(" "), (scope.row.complaintReason == 7) ? _c('span', [_vm._v("投诉职能人员")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "投诉状态",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 0) ? _c('span', [_vm._v("新增投诉/待处理")]) : _vm._e(), _vm._v(" "), (scope.row.status == 1) ? _c('span', [_vm._v("已受理")]) : _vm._e(), _vm._v(" "), (scope.row.status == 2) ? _c('span', [_vm._v("处理完成")]) : _vm._e(), _vm._v(" "), (scope.row.status == 3) ? _c('span', [_vm._v("已判断")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resultFeedback",
      "label": "是否满意",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.resultFeedback == 0) ? _c('span', [_vm._v("未反馈")]) : _vm._e(), _vm._v(" "), (scope.row.resultFeedback == 1) ? _c('span', [_vm._v("满意")]) : _vm._e(), _vm._v(" "), (scope.row.resultFeedback == 2) ? _c('span', [_vm._v("不满意")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isValid",
      "label": "是否有效",
      "show-overflow-tooltip": true,
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.isValid == 0 ? '否' : '是'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "操作",
      "fixed": "right",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.viewDetail(scope.row)
            }
          }
        }, [_vm._v("查看详情")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.queryForm.pageNo,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.queryForm.pageSize,
      "prev-text": "上一页",
      "next-text": "下一页",
      "layout": "prev, next"
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "评价详情",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('p', {
    staticClass: "bold"
  }, [_vm._v("投诉信息")]), _vm._v(" "), _c('p', [_vm._v("投诉人："), _c('span', {
    staticClass: "c6"
  }, [_vm._v(_vm._s(_vm.complaintDetail.userName))])]), _vm._v(" "), _c('p', [_vm._v("联系方式："), _c('span', {
    staticClass: "c6"
  }, [_vm._v(_vm._s(_vm.complaintDetail.linkmanTel))])]), _vm._v(" "), _c('p', [_vm._v("\n                投诉原因：\n                "), _c('span', {
    staticClass: "c6"
  }, [_vm._v(_vm._s(_vm.complaintDetail.complaintReason))])]), _vm._v(" "), _c('p', [_vm._v("\n                投诉状态：\n                "), (_vm.complaintDetail.status == 0) ? _c('span', {
    staticClass: "blue"
  }, [_vm._v("新增投诉/待处理")]) : _vm._e(), _vm._v(" "), (_vm.complaintDetail.status == 1) ? _c('span', {
    staticClass: "blue"
  }, [_vm._v("已受理")]) : _vm._e(), _vm._v(" "), (_vm.complaintDetail.status == 2) ? _c('span', {
    staticClass: "blue"
  }, [_vm._v("处理完成")]) : _vm._e(), _vm._v(" "), (_vm.complaintDetail.status == 3) ? _c('span', {
    staticClass: "blue"
  }, [_vm._v("已判断")]) : _vm._e()]), _vm._v(" "), (_vm.complaintDetail.complaintContent) ? _c('p', [_vm._v("投诉内容："), _c('span', {
    staticClass: "c6"
  }, [_vm._v(_vm._s(_vm.complaintDetail.complaintContent))])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "pb10"
  }, [_vm._v("\n                投诉图片：\n                "), _vm._l((_vm.complaintDetail.picList), function(item) {
    return _c('img', {
      staticStyle: {
        "margin-right": "10px",
        "vertical-align": "top",
        "cursor": "pointer"
      },
      attrs: {
        "src": item,
        "width": "60",
        "height": "60",
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.preview(item)
        }
      }
    })
  })], 2), _vm._v(" "), _c('p', [(_vm.complaintDetail.status == 0) ? _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.dispose(_vm.complaintDetail)
      }
    }
  }, [_vm._v("受理投诉")]) : _vm._e(), _vm._v(" "), (_vm.complaintDetail.status == 1) ? _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.dispose(_vm.complaintDetail)
      }
    }
  }, [_vm._v("反馈结果")]) : _vm._e(), _vm._v(" "), (_vm.complaintDetail.status == 2) ? _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.dispose(_vm.complaintDetail)
      }
    }
  }, [_vm._v("是否有效")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "line",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v("投诉信息")]), _vm._v(" "), _c('p', [_vm._v("订单号："), _c('span', {
    staticClass: "c6"
  }, [_vm._v(_vm._s(_vm.orderDetail.id))])]), _vm._v(" "), _c('p', [_vm._v("支付时间："), _c('span', {
    staticClass: "c6"
  }, [_vm._v(_vm._s(_vm.orderDetail.statusPayedTime))])]), _vm._v(" "), _c('p', [_vm._v("\n                订单状态：\n                "), (_vm.orderDetail.orderStatus == 1000) ? _c('span', {
    staticClass: "c6"
  }, [_vm._v("待付款")]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.orderStatus == 1001) ? _c('span', {
    staticClass: "c6"
  }, [_vm._v("已支付")]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.orderStatus == 2002) ? _c('span', {
    staticClass: "c6"
  }, [_vm._v("配送完成")]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.orderStatus == 3001) ? _c('span', {
    staticClass: "c6"
  }, [_vm._v("确认收货")]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.orderStatus == 9000) ? _c('span', {
    staticClass: "c6"
  }, [_vm._v("已取消")]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.orderStatus == 8000) ? _c('span', {
    staticClass: "c6"
  }, [_vm._v("错误")]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v("联系电话："), _c('span', {
    staticClass: "c6"
  }, [_vm._v(_vm._s(_vm.orderDetail.consigneeTel))])]), _vm._v(" "), _c('p', [_vm._v("联系地址："), _c('span', {
    staticClass: "c6"
  }, [_vm._v(_vm._s(_vm.orderDetail.fullAddressDetail))])]), _vm._v(" "), _c('p', [_vm._v("\n                商品列表：\n                "), _c('el-table', {
    attrs: {
      "border": "",
      "data": _vm.orderDetail.goodsDetailList
    }
  }, [_c('el-table-column', {
    attrs: {
      "property": "title",
      "label": "商品名称",
      "width": "160",
      "show-overflow-tooltip": true
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.isGift == 4 ? '' : scope.row.title) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "specification",
      "label": "规格",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "attribute",
      "label": "属性",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.isGift == 4 ? scope.row.title : scope.row.attribute) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "number",
      "label": "数量",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "salePrice",
      "label": "售价",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "amount",
      "label": "金额"
    }
  })], 1)], 1), _vm._v(" "), _c('p', [_vm._v("打包费："), _c('span', {
    staticClass: "c6"
  }, [_vm._v(_vm._s(_vm.orderDetail.packingFeeReal))])]), _vm._v(" "), _c('p', [_vm._v("配送费："), _c('span', {
    staticClass: "c6"
  }, [_vm._v(_vm._s(_vm.orderDetail.deliveryFee))])]), _vm._v(" "), _c('p', {
    staticClass: "pb10"
  }, [_vm._v("总计："), _c('span', {
    staticClass: "c6"
  }, [_vm._v(_vm._s(_vm.orderDetail.realPay))])]), _vm._v(" "), _c('div', {
    staticClass: "line",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }), _vm._v(" "), (_vm.complaintDetail.recordList && _vm.complaintDetail.recordList.length > 0) ? _c('p', {
    staticClass: "bold"
  }, [_vm._v("处理记录")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.complaintDetail.recordList), function(item, index) {
    return _c('div', {
      key: index
    }, [_vm._v("\n                " + _vm._s(index + 1) + "、" + _vm._s(item.createTime) + " " + _vm._s(item.handManName) + "\n                "), (item.afterStatus == 1) ? _c('span', [_vm._v("受理此投诉单")]) : _vm._e(), _vm._v(" "), (item.afterStatus == 2) ? _c('span', [_vm._v("反馈投诉结果")]) : _vm._e(), _vm._v(" "), (item.afterStatus == 3) ? _c('span', [_vm._v("判定投诉结果")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.replyContent))])])
  })], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "预览",
      "visible": _vm.innerVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.innerVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.previewUrl,
      "width": "100%",
      "alt": ""
    }
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.disposeTitle,
      "visible": _vm.disposeVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.disposeVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "disposeForm",
    attrs: {
      "size": "mini",
      "model": _vm.disposeForm,
      "label-width": _vm.formLabelWidth,
      "rules": _vm.rules
    }
  }, [(_vm.complaintDetail.status == 0 || _vm.complaintDetail.status == 1) ? _c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "replyContent"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入（50个汉字以内）",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.disposeForm.replyContent),
      callback: function($$v) {
        _vm.$set(_vm.disposeForm, "replyContent", $$v)
      },
      expression: "disposeForm.replyContent"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.complaintDetail.status == 2) ? _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.disposeForm.isValid),
      callback: function($$v) {
        _vm.$set(_vm.disposeForm, "isValid", $$v)
      },
      expression: "disposeForm.isValid"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("有效")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("无效")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.disposeVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "loading": _vm.loading1
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('disposeForm')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b8dc3d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/aftersale/complaint/list.vue
// module id = 903
// module chunks = 0